export default __webpack_public_path__ + "static/media/blender.9c64a1e5.jpg";